import { useState, useEffect, useContext } from "react";
import { createContext } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../Data/Uploader";

const ProductContext = createContext();
function ProductProvider({ children }) {
  const [productSet, setProductSet] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");
  // console.log(productSet, isLoading);
  console.log(error);
  useEffect(function () {
    async function fetchProductData() {
      try {
        setIsLoading(true);
        const querySnapshot = await getDocs(collection(db, "products"));

        if (querySnapshot.empty)
          throw new Error(
            "Could not load your products , please check your internet connection 😢 :)"
          );
        setProductSet(
          querySnapshot.docs.map((doc) => {
            return { id: doc.id, ...doc.data() };
          })
        );
        // querySnapshot.forEach((doc) => {
        //   // doc.data() is never undefined for query doc snapshots

        //   setProductSet((product) => {
        //     // if (product.length < 25)
        //     return [...product, { ...doc.data(), id: doc.id }];
        //   });
        // });
      } catch (err) {
        console.log(err.message);
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    }
    fetchProductData();
  }, []);

  return (
    <ProductContext.Provider value={{ productSet, isLoading, error }}>
      {children}
    </ProductContext.Provider>
  );
}

function useClothContext() {
  const context = useContext(ProductContext);
  if (context === undefined)
    throw new Error("ProductContext cannot be used outside ProductProvider  ");
  return context;
}

export { ProductProvider, useClothContext };
